import React from 'react';
import { ResponsiveContext, Box, Layer, Text, Select, Anchor, Button, RadioButtonGroup } from 'grommet';
import { FormClose } from 'grommet-icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { TitleSideBar, TitleField } from '../../../components';

import { closeLayer } from '../../../actions/layers';
import { searchCityOptions, searchDistrictOptions } from '../../../actions/select-options';
import { changeValues, cleanValues } from '../../../actions/form';
import { searchCandidate } from '../../../actions/search-election';

import electionsOptions from '../../../constants/elections';
import positionsOptions from '../../../constants/positions';

const FormSearch = (props) => {
  if(!props.toggleLayer || props.toggleLayer !== 'search') return null;

  const onSearchCities = ({ text }) => {
    if (text.length < 2) return;

    const { searchCityOptions } = props;
    searchCityOptions({ name: text });
  }

  const onSearch = (params) => {
    const { searchCandidate, closeLayer } = props;

    searchCandidate({
      values: params
    });

    closeLayer();
  }

  const {
    // data
    partiesOptions,
    citiesOptions,

    // functions
    closeLayer,
    changeValues,
    cleanValues,

    // fields
    electionId,
    cityId,
    candidatePositionId,
    partyId,
  } = props;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Layer
          responsive={false}
          full='vertical'
          position='left'
          onClickOutside={closeLayer}
          onEsc={closeLayer}
        >
          <Box
            fill='vertical'
            width={ size === 'xsmall' || size === 'small' ? '100vw' : '60vw'}
            pad={{ top: 'large', bottom: 'xsmall' }}
            overflow='auto'
            flex
          >
            <Box
              direction='row'
              justify='between'
              margin={{ bottom: 'medium', horizontal: 'large' }}
            >
              <TitleSideBar value='Filtrar' />

              <Button
                plain
                title='Fechar'
                icon={<FormClose />}
                onClick={closeLayer}
              />
            </Box>

            {/* Campos de busca */}
            <Box flex overflow='auto'>

              { /* City */ }
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Box direction='row' align='center' gap='xsmall'>
                  <TitleField text='Cidade' />

                  {cityId && (
                    <Anchor
                      size='small'
                      label='limpar'
                      onClick={() => {
                        changeValues({ fieldName: 'cityId', value: null });
                      }}
                    />
                  )}
                </Box>

                <Select
                  options={citiesOptions}
                  labelKey={
                    ({ name, stateAbbrev }) => (
                      <Box
                        pad={{ horizontal: 'small', vertical: 'small' }}
                        gap='xsmall'
                        direction='row'
                        align='baseline'
                      >
                        <Text size='medium' color='dark-1'>{name}</Text>
                        <Text size='small' color='dark-6'>{stateAbbrev}</Text>
                      </Box>
                    )
                  }
                  valueKey={{ key: 'id', reduce: true }}
                  value={cityId ?? ''}
                  searchPlaceholder='Digite para buscar...'
                  emptySearchMessage=''
                  onChange={({ value: nextValue }) => changeValues({ fieldName: 'cityId', value: nextValue }) }
                  onSearch={ text => onSearchCities({ text }) }
                >
                  {({ name, stateAbbrev }) => {
                    return (
                      <Box
                        pad={{ horizontal: 'small', vertical: 'small' }}
                        gap='small'
                        direction='row'
                        align='baseline'
                      >
                        <Text size='medium' color='dark-1'>{name}</Text>
                        <Text size='small' color='dark-6'>{stateAbbrev}</Text>
                      </Box>
                    )
                  }}
                </Select>
              </Box>


              { /* Elections */ }
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Select
                  options={electionsOptions}
                  labelKey='name'
                  valueKey={{ key: 'id', reduce: true }}
                  value={electionId ?? ''}
                  emptySearchMessage=''
                  onChange={({ value: nextValue }) =>
                    changeValues({ fieldName: 'electionId', value: nextValue })
                  }
                />
              </Box>

              { /* Posição */ }
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
              >
                <Box direction='row' align='center' gap='xsmall'>
                  <TitleField text='Cargo' />

                  {candidatePositionId && (
                    <Anchor
                      size='small'
                      label='limpar'
                      onClick={() => changeValues({ fieldName: 'candidatePositionId', value: null })}
                    />
                  )}
                </Box>

                <Box
                  pad={{ vertical: 'small' }}
                >
                  <RadioButtonGroup
                    name='candidatePositionId'
                    value={candidatePositionId ?? ''}
                    options={
                      positionsOptions.map(({ id, name }) => ({
                        label: name,
                        id: `positionId_${id}`,
                        value: id.toString(),
                      }))
                    }
                    onChange={event => { changeValues({ fieldName: 'candidatePositionId', value: event.target.value }) }}
                    wrap={true}
                    direction='row'
                  >
                    {(option, { checked }) => {
                      let background = null;
                      let borderColor = 'dark-5';

                      if(checked) {
                        background = 'brand';
                        borderColor = 'brand';
                      }

                      return (
                        <Box
                          direction='row'
                          gap='small'
                          align='center'
                          width={{ min: 'medium' }}
                          margin={{ bottom: 'small' }}
                        >
                          <Box
                            width={'20px'}
                            height={'20px'}
                            background={background}
                            round='xxsmall'
                            border={{
                              color: borderColor
                            }}
                          />
                          <Text color='dark-2' size='small'>{option.label}</Text>
                        </Box>
                      )
                    }}
                  </RadioButtonGroup>
                </Box>
              </Box>


              { /* Partidos */ }
              <Box
                margin={{
                  vertical: size === 'small' ? 'medium' : 'small',
                  horizontal: 'large'
                }}
                flex={{ shrink: 0 }}
                //fill
              >
                <Box direction='row' align='center' gap='xsmall'>
                  <TitleField text='Partido' />

                  {partyId && (
                    <Anchor
                      size='small'
                      label='limpar'
                      onClick={() => changeValues({ fieldName: 'partyId', value: null })}
                    />
                  )}
                </Box>

                <Box
                  pad={{ vertical: 'small' }}
                >
                  <RadioButtonGroup
                    name='partyId'
                    value={partyId ?? ''}
                    options={
                      partiesOptions.map(({ id, name }) => ({
                        label: name,
                        id: `partyId_${id}`,
                        value: id.toString(),
                      }))
                    }
                    onChange={event => { changeValues({ fieldName: 'partyId', value: event.target.value }) }}
                    wrap={true}
                    direction='row'
                  >
                    {(option, { checked }) => {
                      let background = null;
                      let borderColor = 'dark-5';

                      if(checked) {
                        background = 'brand';
                        borderColor = 'brand';
                      }

                      return (
                        <Box
                          direction='row'
                          gap='small'
                          align='center'
                          width={{ min: 'medium' }}
                          margin={{ bottom: 'small' }}
                        >
                          <Box
                            width={'20px'}
                            height={'20px'}
                            background={background}
                            round='xxsmall'
                            border={{
                              color: borderColor
                            }}
                          />
                          <Text color='dark-2' size='small'>{option.label}</Text>
                        </Box>
                      )
                    }}
                  </RadioButtonGroup>
                </Box>
              </Box>
            </Box>

            {/* Botões Busca/limpa */}
            <Box
              direction='row'
              pad={{ vertical: 'medium' }}
              margin={{ horizontal: 'large' }}
              justify='center'
              align='center'
              gap='small'
            >
              <Box width='small'>
                <Button
                  color='dark-3'
                  label='Limpar'
                  onClick={() => cleanValues() }
                />
              </Box>

              <Box width='small'>
                <Button
                  color='brand'
                  primary
                  label='Buscar'
                  title={
                    !electionId || !cityId ? 'Selecione uma cidade.' : ''
                  }
                  disabled={!electionId || !cityId}
                  onClick={() =>
                    onSearch({
                      electionId,
                      cityId,
                      candidatePositionId,
                      partyId,
                    })
                  }
                />
              </Box>
            </Box>
          </Box>
        </Layer>
      )}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ layerReducer, queriesReducer, formReducer }) => ({
  toggleLayer: layerReducer.toggleLayer,
  partiesOptions: queriesReducer.partiesOptions,
  citiesOptions: queriesReducer.citiesOptions,

  electionId: formReducer.electionId || 1,
  cityId: formReducer.cityId,
  candidatePositionId: formReducer.candidatePositionId,
  partyId: formReducer.partyId,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    closeLayer,
    searchCityOptions,
    searchDistrictOptions,
    changeValues,
    cleanValues,
    searchCandidate,
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(FormSearch);
